module.exports = __webpack_public_path__ + "img/d5.74a384c4.png";